import { WidgetSettingsType } from '@thingslog/repositories';
import {
  BarChartWidget,
  LineChartWidget,
  Widget,
  AreaChartWidget,
  GaugeWidget,
  PieChartWidget,
  TableWidget,
  ValueWidget,
} from '../components/widgets';

export class WidgetFactory {
  public static create(type: WidgetSettingsType): Widget {
    switch (type) {
      case 'line-chart':
        return new LineChartWidget();
      case 'bar-chart':
        return new BarChartWidget();
      case 'pie-chart':
        return new PieChartWidget();
      case 'area-chart':
        return new AreaChartWidget();
      case 'gauge':
        return new GaugeWidget();
      case 'value':
        return new ValueWidget();
      case 'table':
        return new TableWidget();
      default:
        throw new Error('Invalid widget type');
    }
  }
}
